import { Navigate } from "react-router-dom";

const ProfileSetup = () => <Navigate to="/organizations" replace />;
export default ProfileSetup;
